export interface ShareWindowOptions {
  width?: number
  height?: number
}

export function openShareWindow(url: string, options?: ShareWindowOptions) {
  try {
    const { width = 600, height = 500 } = options || {}
    const left = Math.max(0, (window.screen.width - width) / 2)
    const top = Math.max(0, (window.screen.height - height) / 2)
    const features = `width=${width},height=${height},left=${left},top=${top},toolbar=0,status=0,menubar=0`
    window.open(url, 'share', features)
  } catch (err) {
    console.error('Failed to open share window:', err)
    window.open(url, '_blank')
  }
}
